var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTake(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.18 20H8.033a.821.821 0 01-.82-.82v-6.139a.492.492 0 11.984 0v5.975h10.816V.983H8.193v6.156a.492.492 0 11-.984 0V.819a.821.821 0 01.82-.82h11.148a.821.821 0 01.82.82V19.18a.821.821 0 01-.817.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.262 10.492H.492a.492.492 0 110-.984h13.77a.492.492 0 110 .984z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.328 14.427a.492.492 0 01-.348-.84l3.587-3.586L9.98 6.414a.495.495 0 01.7-.7l3.934 3.935a.492.492 0 010 .7l-3.934 3.934a.49.49 0 01-.352.144z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTake);
export default __webpack_public_path__ + "static/media/Take.28d6721ab9b5e22311a1334db7df1685.svg";
export { ForwardRef as ReactComponent };